import { useEffect } from 'react';
import { useAppStore } from '../store/useAppStore.js';

export function DataProvider({ children }) {
  const loading = useAppStore((s) => s.loading);

  useEffect(() => {
    useAppStore.getState().hydrate();
    return () => useAppStore.getState().stopPolling();
  }, []);

  if (loading) {
    return <LoadingSkeleton />;
  }

  return children;
}

function LoadingSkeleton() {
  return (
    <div className="p-6 space-y-6 max-w-5xl">
      {/* Title */}
      <div className="h-6 w-24 animate-pulse rounded bg-slate-200" />
      {/* Metrics cards */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="rounded border border-slate-200 p-4 space-y-2">
            <div className="h-3 w-16 animate-pulse rounded bg-slate-200" />
            <div className="h-7 w-10 animate-pulse rounded bg-slate-200" />
          </div>
        ))}
      </div>
      {/* Actions section */}
      <div className="rounded border border-slate-200 p-4 space-y-3">
        <div className="h-4 w-32 animate-pulse rounded bg-slate-200" />
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="h-10 w-full animate-pulse rounded bg-slate-100" />
        ))}
      </div>
    </div>
  );
}
